import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ADMIN_DOMAIN = "brandfinish.com";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#A3A3A3] font-mono text-sm">
        loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.email.toLowerCase().endsWith(`@${ADMIN_DOMAIN}`)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
